import { useState, useCallback } from "react"

const useHandleModalShow = (modalExtraFunc = null) => {
    const [modalItemShow, setModalItemShow] = useState(false)
    const handleClose = useCallback(() => {
        setModalItemShow(false)
        if (modalExtraFunc) modalExtraFunc()
    }, [modalItemShow, modalExtraFunc])
    const handleModalItemShowChange = useCallback((showStatus) => {
        setModalItemShow(showStatus)
    }, [])

    return { modalItemShow, setModalItemShow, handleClose, handleModalItemShowChange }
}

export default useHandleModalShow
